import { useQuery } from "@tanstack/react-query";

import api from "../apiClient";

import cookiesHelper from "../../helpers/cookies";

import { ICertificateAwardsReportData } from "../../interfaces/analytics";

const useGetCertificateAwardsReport = (filterQuery: string) => {
    const queryFn = async (): Promise<ICertificateAwardsReportData> => {
        const token = cookiesHelper.getCookie((process.env.REACT_APP_AUTH_TOKEN_NAME as string));
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

        const res = await api.get(`analytics/certificate-awards-report?${filterQuery}`);
        return res.data;
    };

    return useQuery({
        queryKey: ['certificate-awards-report', filterQuery],
        queryFn,
        retry: 0,
    });
};

export default useGetCertificateAwardsReport;